import React from 'react';
import { motion } from 'framer-motion';
// import { FaGithub, FaLinkedin } from "react-icons/fa";


const GitHubIcon = (
  <svg viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg" className="w-9 h-9 md:w-10 md:h-10">
    <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/>
  </svg>
);

const LinkedInIcon = (
  <svg viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg" className="w-9 h-9 md:w-10 md:h-10">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.063 2.063 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const DESKTOP_APPS = {
  developer: [
    // { id: 'github', label: 'GitHub', icon: '🐙', colors: ['#2b3137', '#1a1e22'] },
    { id: 'github', label: 'GitHub', svg: GitHubIcon, colors: ['#2b3137', '#1a1e22'] },
    // { id: 'linkedin', label: 'LinkedIn', svg: LinkedInIcon, colors: ['#0A66C2', '#004182'] },
    { id: 'ml-models', label: 'ML Models', icon: '🧠', colors: ['#7C3AED', '#4338CA'] },
    { id: 'linkedin', label: 'LinkedIn', svg: LinkedInIcon, colors: ['#0A66C2', '#004182'] },
    { id: 'cv', label: 'CV', icon: '📄', colors: ['#007AFF', '#0055CC'] },
    { id: 'certifications', label: 'Certs', icon: '🏅', colors: ['#F59E0B', '#D97706'] },
    { id: 'contact', label: 'Contact', icon: '📬', colors: ['#10B981', '#059669'] },
  ],
  recruiter: [
    { id: 'cv', label: 'CV', icon: '📄', colors: ['#007AFF', '#0055CC'] },
    { id: 'impact-stories', label: 'Impact', icon: '📊', colors: ['#8B5CF6', '#7C3AED'] },
    { id: 'linkedin', label: 'LinkedIn', svg: LinkedInIcon, colors: ['#0A66C2', '#004182'] },
    { id: 'certifications', label: 'Certs', icon: '🏅', colors: ['#F59E0B', '#D97706'] },
    { id: 'contact', label: 'Contact', icon: '📬', colors: ['#10B981', '#059669'] },
  ],
  athlete: [],
};

// const GREETINGS = {
//   developer: {
//     title: 'Software Engineer',
//     subtitle: 'Building elegant solutions with modern technologies. Passionate about clean code and user experience.',
//   },
//   recruiter: {
//     title: 'Recruiter / Manager',
//     subtitle: 'Experienced professional with a proven track record in delivering high-quality software solutions.',
//   },
//   athlete: {
//     title: 'Athlete / Enthusiast',
//     subtitle: 'Combining physical discipline with technical excellence.',
//   },
// };

const ComingSoon = () => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    className="min-h-[60vh] flex flex-col items-center justify-center px-6"
  >
    <div className="text-8xl mb-8">🚧</div>
    <h2 className="text-4xl font-bold text-pure-white mb-4">Coming Soon</h2>
    <p className="text-gray-400 text-lg text-center max-w-md">
      This section is under construction. Check back later for updates on achievements and activities!
    </p>
  </motion.div>
);

const Desktop = ({ persona, onOpenApp }) => {
  const apps = DESKTOP_APPS[persona] || [];
//   const greeting = GREETINGS[persona] || GREETINGS.developer;

  if (persona === 'athlete') {
    return (
      <section className="min-h-screen flex items-center justify-center pt-32">
        <ComingSoon />
      </section>
    );
  }

  return (
    <section className="min-h-screen flex flex-col items-center justify-center px-6"> 
      {/* Greeting
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1, duration: 0.6 }}
        className="text-center mb-20"
      >
        <h1 className="text-5xl md:text-7xl font-bold text-pure-white mb-5 tracking-tight">
          {greeting.title}
        </h1>
        <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto leading-relaxed">
          {greeting.subtitle}
        </p>
      </motion.div> */}

      {/* App Icon Grid */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.15, duration: 0.6 }}
        className="flex flex-wrap justify-center gap-10 md:gap-14"
      >
        {apps.map((app, index) => (
          <motion.button
            key={app.id}
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
              delay: 0.2 + index * 0.08,
              type: 'spring',
              stiffness: 300,
              damping: 20,
            }}
            whileHover={{ scale: 1.12, y: -6 }}
            whileTap={{ scale: 0.88 }}
            onClick={() => onOpenApp(app.id)}
            className="flex flex-col items-center gap-2.5 group outline-none"
          >
            {/* Icon Tile */}
            <div
              className="w-16 h-16 md:w-[72px] md:h-[72px] rounded-[18px] md:rounded-[20px] flex items-center justify-center transition-shadow duration-300"
              style={{
                background: `linear-gradient(145deg, ${app.colors[0]}, ${app.colors[1]})`,
                boxShadow: `0 4px 20px ${app.colors[0]}50, inset 0 1px 0 rgba(255,255,255,0.1)`,
              }}
            >
              {/* <span className="text-3xl md:text-[34px] select-none">{app.icon}</span> */}
              {app.svg ? (
                app.svg
              ) : (
                <span className="text-3xl md:text-[34px] select-none">{app.icon}</span>
              )}

            </div>
            {/* Label */}
            <span className="text-[11px] text-gray-500 group-hover:text-pure-white transition-colors font-medium tracking-wide">
              {app.label}
            </span>
          </motion.button>
        ))}
      </motion.div>

      {/* Home Indicator Bar */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
        className="fixed bottom-3 left-1/2 -translate-x-1/2"
      >
        <div className="w-32 h-1 bg-white/20 rounded-full" />
      </motion.div>
    </section>
  );
};

export default Desktop;
